import { InitPasswordByLinkRequestPayload } from "@/data/payload/auth/init-password-by-lint-request-payload";
import { UserPasswordManageRepository } from "@/domain/repository/user-password-reset-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class InitDoctorPasswordSettingUsecase {
  constructor(private readonly userPasswordManageRepository: UserPasswordManageRepository) {}

  async execute(token: string, newSn: string): Promise<SATResult<void, SATError>> {
    const payload: InitPasswordByLinkRequestPayload = {
      token: token,
      newSn: newSn,
    };

    return this.userPasswordManageRepository.setInitialPasswordByLink(payload);
  }
}
